import React from 'react';
import AbandonedBusinessLayout from '../../components/abandoned-business/AbandonedBusinessLayout';
import AbandonedBusinessPage from '../../components/abandoned-business/AbandonedBusinessPage';
import './AbandonedBusiness.scss';

const AbandonedBusiness: React.FC = () => (
  <div className='abandoned-business'>
    <AbandonedBusinessLayout>
      <AbandonedBusinessPage />
    </AbandonedBusinessLayout>
  </div>
);

export default AbandonedBusiness;

